import Input from "@/components/Input/Input";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { formatCurrency } from "@/utils/currency";
import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: number;
  onChange?: (value?: number) => void;
  inputClassName?: string;
  allowNegative?: boolean;
  currencyCode: string;
  locale?: string;
  step?: number;
};

/**
 * Card-based Form / CurrencyItem
 * 金額を扱うためのフォームアイテム
 */
export const CFormCurrencyItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={
        <Text variant="p">
          {props.value !== undefined
            ? formatCurrency({
                amount: props.value,
                currencyCode: props.currencyCode,
                locale: props.locale,
              })
            : "-"}
        </Text>
      }
      writeComponent={
        <HStack className="gap-2 items-center">
          <Input
            type="number"
            inputMode="decimal"
            min={props.allowNegative ? undefined : 0}
            step={props.step ?? "0.01"}
            value={props.value ?? ""}
            onChange={(e) => {
              const value =
                e.target.value === "" ? undefined : parseFloat(e.target.value);
              props.onChange?.(value);
            }}
            className={props.inputClassName ?? "w-[120px]"}
          />
          <Text variant="labelReg">{props.currencyCode}</Text>
        </HStack>
      }
    />
  );
});
